import { render, staticRenderFns } from "./leason.vue?vue&type=template&id=c1beab1c&scoped=true&"
import script from "./leason.vue?vue&type=script&lang=js&"
export * from "./leason.vue?vue&type=script&lang=js&"
import style0 from "./leason.vue?vue&type=style&index=0&id=c1beab1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1beab1c",
  null
  
)

export default component.exports